import { render, staticRenderFns } from "./InputResults.vue?vue&type=template&id=174f704f&"
import script from "./InputResults.vue?vue&type=script&lang=js&"
export * from "./InputResults.vue?vue&type=script&lang=js&"
import style0 from "./InputResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports